<template>
  <router-view></router-view>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    components: {},
    computed: {},
    props: {
      source: String,
    },
    watch: {},
    data: () => ({}),
    mounted() {
      this.$store.dispatch("disciplines/loadAll");
      this.$store.dispatch("divisions/loadAll");
    },
    methods: {},
  };
</script>
